import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useForm, useWatch } from "react-hook-form";
import { isEmpty } from "lodash";
import { Button, message, Spin } from "antd";
import dayjs from "dayjs";
import Input from "../../Components/CommonCommponents/Input";
import Checkbox from "../../Components/CommonCommponents/Checkbox";
import DatePicker from "../../Components/CommonCommponents/DatePicker";
import RangePicker from "../../Components/CommonCommponents/RangePicker";
import TextEdit from "../../Components/CommonCommponents/TextEditor";
import CandodateService from "../../Service.js/CandidateService";
import toast from "react-hot-toast";

export default function RequiredFieldProjectModal(props) {
  const { isEditForm, close, projects, editIndex, candidateId } = props;
  const params = useParams();

  const defaultValues = {
    company: isEditForm ? props?.details?.company : "",
    project: isEditForm ? props?.details?.project : "",
    designation: isEditForm ? props?.details?.designation : "",
    isCurrentProject: isEditForm ? props?.details?.is_current_project : false,
    workedFrom: isEditForm ? dayjs(props?.details?.worked_from) : "",
    duration: isEditForm
      ? [dayjs(props?.details?.worked_from), dayjs(props?.details?.worked_till)]
      : [],
    description: isEditForm ? props?.details?.description : "",
  };

  const {
    handleSubmit,
    control,
    setValue,
    register,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues,
    mode: "all",
  });
  const DEFAULT_ERROR_MESSAGE =
    "Something went wrong, Please try again after sometime";
  const isCurrentProject = useWatch({ control, name: "isCurrentProject" });
  const [messageApi, contextHolder] = message.useMessage();

  const sendData = async (data) => {
    await CandodateService.addProject(data)
      .then(
        (oResponse) => {
          console.log("oResponse", oResponse);
          toast.success("Successfully Added!");
          props?.setEnable(true);
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
        toast.error("Failed To Add");
      });
  };
  const updateData = async (data) => {
    await CandodateService.updateProjects(data, props?.details?.id)
      .then(
        (oResponse) => {
          console.log("oResponse", oResponse);
          toast.success("Successfully Added!");
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
        toast.error("Failed To Add");
      });
  };
  const onSubmit = async (fields) => {
    try {
      const { company, project, designation, isCurrentProject, description } =
        fields;

      const data = {
        candidate: candidateId,
        company,
        project,
        designation,
        is_current_project: isCurrentProject,
        description,
      };

      if (isCurrentProject) {
        data["worked_from"] = dayjs(fields.workedFrom).format("YYYY-MM-DD");
      } else {
        data["worked_from"] = dayjs(fields.duration[0]).format("YYYY-MM-DD");
        data["worked_till"] = dayjs(fields.duration[1]).format("YYYY-MM-DD");
      }

      // if (isEditForm) {
      //   await editProject({ body: data, projectId: props?.details?.id });
      // } else {
      //   await addProject(data);
      // }
      if (isEditForm) {
        updateData(data);
      } else {
        sendData(data);
      }
      close();
    } catch (error) {
      console.error("Submission Error", error);
    }
  };

  const onTextAreaChange = (text) => {
    if (!isEmpty(errors?.responsibilities) && text.length > 0) {
      clearErrors("responsibilities");
    }
    setValue("responsibilities", text);
  };

  return (
    <div className="w-full px-10 pt-8">
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col">
        <div className="w-full">
          <Input
            label="Company"
            name="company"
            control={control}
            rules={{
              required: "This Field is Required",
              pattern: {
                value: /[a-zA-Z]/g,
                message: "Invalid Company Name",
              },
            }}
            placeholder="Name"
          />
        </div>
        <div className="w-full">
          <Input
            label="Designation"
            name="designation"
            placeholder="Title/Role Name"
            control={control}
            rules={{
              required: "This Field is Required",
              pattern: {
                value: /[a-zA-Z]/g,
                message: "Please enter letters only",
              },
            }}
          />
        </div>
        <div className="w-full">
          <Input
            label="Project"
            name="project"
            placeholder="Title/Role Name"
            control={control}
            rules={{
              required: "This Field is Required",
              pattern: {
                value: /[a-zA-Z]/g,
                message: "Please enter letters only",
              },
            }}
          />
        </div>
        <div className="w-full">
          <Checkbox
            label="Current Project?"
            name="isCurrentProject"
            control={control}
            showUpperLabel={false}
          />
        </div>
        <div className="w-full">
          {isCurrentProject ? (
            <DatePicker
              label="Starting Date"
              name="workedFrom"
              control={control}
              noTextInput
              rules={{
                required: "Please Choose a Date",
              }}
              disableFutureDays
            />
          ) : (
            <RangePicker
              label="Duration"
              name="duration"
              control={control}
              rules={{
                required: "Please Choose a Date",
              }}
              disableFutureDays
            />
          )}
        </div>
        <div>
          <div>Responsibilities</div>
          <TextEdit
            initialValue={isEditForm ? props?.details?.responsibilities : ""}
            onChange={onTextAreaChange}
          />
          {errors?.responsibilities && (
            <div className="text-errorMain">
              {errors?.responsibilities?.message}
            </div>
          )}
        </div>

        <div className="flex ml-auto mt-4 gap-4">
          {contextHolder}
          <Button
            isCancel
            htmlType="submit"
            disabled={false}
            children="Cancel"
            onClick={close}
          />
          <Button type="primary" htmlType="submit" disabled={false}>
            Add
          </Button>
        </div>
      </form>
    </div>
  );
}
